/**
 * 対局・ロビーで使う コンパクト title bar。
 *
 * 左: 戻るボタン (任意) + タイトル
 * 中央: 任意の slot (例: ルームコード)
 * 右: ハンバーガーメニュー
 */

import type { ReactNode } from 'react';
import { onLinkClick } from '../lib/navigate';
import { Icon } from './Icon';
import { type NavItem, NavMenu } from './NavMenu';

interface Props {
  title?: string;
  back?: { href: string; label?: string };
  center?: ReactNode;
  menu?: NavItem[];
}

export function TitleBar({ title, back, center, menu }: Props) {
  return (
    <header className="title-bar">
      <div className="title-bar-side">
        {back && (
          <a
            className="title-bar-back"
            href={back.href}
            onClick={onLinkClick(back.href)}
            aria-label={back.label ?? '戻る'}
          >
            <Icon name="back" />
          </a>
        )}
        {title && <span className="title-bar-title">{title}</span>}
      </div>
      <div className="title-bar-center">{center}</div>
      <div className="title-bar-side title-bar-end">
        {menu && menu.length > 0 && <NavMenu items={menu} />}
      </div>
    </header>
  );
}
